import { Icon } from "@iconify/react";
import pieChart2Fill from "@iconify/icons-eva/pie-chart-2-fill";
import peopleFill from "@iconify/icons-eva/people-fill";
import listFill from "@iconify/icons-eva/list-fill";
// import shoppingBagFill from "@iconify/icons-eva/shopping-bag-fill";
// import fileTextFill from "@iconify/icons-eva/file-text-fill";
// import lockFill from "@iconify/icons-eva/lock-fill";
// import personAddFill from "@iconify/icons-eva/person-add-fill";
import patient32Filled from "@iconify/icons-fluent/patient-32-filled";
import { ROUTES } from "../../commons";
// import alertTriangleFill from "@iconify/icons-eva/alert-triangle-fill";

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: "dashboard",
    path: ROUTES.Dashboard,
    icon: getIcon(pieChart2Fill),
  },
  {
    title: "articles",
    path: "/articles",
    icon: getIcon(listFill),
  },
  {
    title: "users",
    path: "/users",
    icon: getIcon(peopleFill),
  },
  {
    title: "patients",
    path: "/patients",
    icon: getIcon(patient32Filled),
  },
  // {
  //   title: "product",
  //   path: "/dashboard/products",
  //   icon: getIcon(shoppingBagFill),
  // },
  // {
  //   title: "blog",
  //   path: "/dashboard/blog",
  //   icon: getIcon(fileTextFill),
  // },
  // {
  //   title: "Not found",
  //   path: "/404",
  //   icon: getIcon(alertTriangleFill),
  // },
];

export default sidebarConfig;
